import { useAuth } from "../context/AuthContext";
import type { SetupTask } from "../components/CompleteSetupTaskList";

const verified = (value: unknown) => value === true || value === 1 || value === "1";

/** Lending requirements must not disappear from a residence-specific progress list. */
export default function useLoanPreApprovalRequirements() {
  const { user } = useAuth();
  const compliance = user?.compliance;
  const tasks: SetupTask[] = [
    { label: "Verify your BVN", description: "Verify your bank identity", completed: verified(compliance?.bvn_verified), route: "/verify-bvn", isModal: true, modalName: "verify-bvn" },
    { label: "Verify your NIN", description: "Verify your identity", completed: verified(compliance?.nin_verified), route: "/verify-nin", isModal: true, modalName: "verify-nin" },
    { label: "Add employment details", description: "Tell us about your employment", completed: Boolean(compliance?.employment_status) || verified(compliance?.added_employment_status), route: "/home/settings/compliance/employment-details" },
  ];
  const missing = tasks.filter((task) => !task.completed);
  return { ready: Boolean(user) && missing.length === 0, missing };
}
